module.exports = __webpack_public_path__ + "img/answer-case.959ebb41.jpg";